import { render, staticRenderFns } from "./AccrualsEstimatesOverflowMenu.vue?vue&type=template&id=b60e52a8&scoped=true"
import script from "./AccrualsEstimatesOverflowMenu.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimatesOverflowMenu.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimatesOverflowMenu.vue?vue&type=style&index=0&id=b60e52a8&prod&lang=scss&scoped=true"
import style1 from "./AccrualsEstimatesOverflowMenu.vue?vue&type=style&index=1&id=b60e52a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60e52a8",
  null
  
)

export default component.exports